module.exports = __webpack_public_path__ + "img/portrait.4d743ff0.png";